module.exports = __webpack_public_path__ + "static/media/tenant_engie_in.c39f4705.svg";